import { createFileRoute, Outlet } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { ZoneProvider } from "@/lib/facility/zone";
import { CommunityNav } from "./-components/community-nav";
import { useCommunityBuilding } from "./-components/use-community-building";

export const Route = createFileRoute("/_authenticated/community")({
  beforeLoad: ({ context }) => guardRoute(context.me, "community"),
  component: CommunityLayout,
});

/** Every community screen: its sidebar beside the page, for the building chosen in the header.
 * Keyed to the building so a switch starts each page afresh. */
function CommunityLayout() {
  const { building, canRead } = useCommunityBuilding();
  if (!building || !canRead) {
    return (
      <>
        <PageHeader title="Community" />
        <EmptyState
          title="Community is not open to you here"
          description={
            building
              ? `You do not have access to the community at ${building.name}. Choose another building at the top of the page.`
              : "You do not have access to a building's community."
          }
        />
      </>
    );
  }
  return (
    <ZoneProvider facilityId={building.id}>
      <div className="@container/community">
        {/* Narrow, the page's own heading comes first, then the row of places, then the page: the
            page's parts join this column (`contents`) so they can be ordered around the row. */}
        <div className="flex flex-col gap-5 @3xl/community:grid @3xl/community:grid-cols-[12rem_minmax(0,1fr)] @3xl/community:items-start @3xl/community:gap-6">
          <CommunityNav facilityId={building.id} />
          <div
            key={building.id}
            className="contents [&>*]:order-3 [&>[data-page-header]]:order-1 @3xl/community:block @3xl/community:min-w-0 @3xl/community:space-y-6"
          >
            <Outlet />
          </div>
        </div>
      </div>
    </ZoneProvider>
  );
}
